<template>
  <!-- slider-area -->
  <section class="slider-area">
    <div class="slider-active">
      <div class="single-slider slider-bg" :class="{
      'slider-bg-off': bviImage.imageMode.value === 'off',
      'slider-bg-grayscale': bviImage.imageMode.value === 'grayscale'
    }" :style="sliderStyles">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-4">
              <div class="slider-content">
                <a href="/anniversary">
                  <img alt="" class="bvi-img" src="@/assets/img/100_j.gif" >
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
<!--  <section class="slider-area">-->
<!--    <div class="slider-active" v-if="readyToMount">-->
<!--      <div v-for="item in elements" :key="item.id">-->
<!--        <div class="single-slider slider-bg" :style="'background-image: url('+item.image_size_1+')'">-->
<!--          <div class="container">-->
<!--            <div class="row">-->
<!--              <div class="col-xl-8 col-lg-10">-->
<!--                <div class="slider-content">-->
<!--                  <img src="@/assets/img/100_j.gif">&ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->
</template>
<script>
import {ref, onMounted, watch, nextTick, computed} from 'vue';
import axios from 'axios';
import getLocaleText from "@/locales/getLocaleText";
import { useBVI } from "@/useBVI";

export default {
  name: 'V_slider',
  setup() {
    const readyToMount = ref(false);
    const elements = ref([]);
    const  bviImage  = useBVI();
    const sliderStyles = computed(() => {
      if (bviImage.imageMode.value === 'off') {
        return { background: '#fff'};
      } else if (bviImage.imageMode.value === 'grayscale') {
        return { filter: 'grayscale(100%)' };
      }
      return {};
    });
    const fetchElements = async () => {
      try {
        const res = await axios.get('slider/');
        elements.value = res.data;
        readyToMount.value = true;
      } catch (error) {
        console.error('API data fetch error:', error);
      }
    };

    const initSlider = () => {
      nextTick(() => {
        let slider = window.$('.slider-active').not('.slick-initialized');

        if (slider.length > 0) {
          slider.on('init', function () {
            let $firstAnimatingElements = window.$('.single-slider:first-child').find('[data-animation]');
            doAnimations($firstAnimatingElements);
          });
          slider.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            let $animatingElements = window.$('.single-slider[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
            doAnimations($animatingElements);
          });
          slider.slick({
            autoplay: true,
            autoplaySpeed: 4000,
            dots: false,
            fade: true,
            arrows: false,
            responsive: [
              { breakpoint: 767, settings: { dots: false, arrows: false } }
            ]
          });
        }
      });

      function doAnimations(elements) {
        let animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        elements.each(function () {
          let $this = window.$(this);
          let $animationDelay = $this.data('delay');
          let $animationType = 'animated ' + $this.data('animation');
          $this.css({
            'animation-delay': $animationDelay,
            '-webkit-animation-delay': $animationDelay
          });
          $this.addClass($animationType).one(animationEndEvents, function () {
            $this.removeClass($animationType);
          });
        });
      }
    };

    onMounted(() => {
      fetchElements();
      console.log('0',bviImage.imageMode.value);
    });

    watch(readyToMount, (newValue) => {
      if (newValue) {
        initSlider();
      }
    });
    // watch(bviImage.imageMode, (newValue) => {
    //   if (newValue) {
    //     console.log("1",newValue);
    //   }
    // })
    return {
      readyToMount,
      elements,
      getLocaleText,
      bviImage,
      sliderStyles
    };
  }
};
</script>
<!--:style="{ backgroundImage: 'url(' + require('@/assets/img/22.jpg') + ')', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }"-->
<style scoped>
.slider-bg{
    background: url('/src/assets/img/22.jpg') no-repeat center center;
    background-size: contain;
}
@media only screen and (max-width: 720px) {
  .slider-bg {
    background-image:none;
  }
}
.slider-bg::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #003580;
  opacity: .5;
  z-index: -1;
}

.slider-bg-off::before {
  display: none;
}

.slider-bg-grayscale {
  filter: grayscale(100%);
}
</style>